<section class="container-fluid werte-container">
  <article class="werte-wrapper container space">
    <div class="row">
      <div class="col-xs-12 col-sm-4">
        <div class="werte-content konzeption">
          <h2>Konzeption</h2>
          <p>Für mich ist ein solides Konzept der Ausgangspunkt für ein erfolgreiches Projekt.</p>
        </div>
      </div>
      <div class="col-xs-12 col-sm-4">
        <div class="werte-content design">
          <h2>UX-Design</h2>
          <p>Webdesign liegt mir sehr am Herzen. Ich glaube immer noch, das der erste Eindruck einer Webseite
            zählt.
            Denn die ersten paar Sekunden entscheiden, ob der Nutzer auf die Webseite wieder kommt.</p>
        </div>
      </div>
      <div class="col-xs-12 col-sm-4">
        <div class="werte-content programming">
          <h2>Entwicklung</h2>
          <p>Neben aller Konzeption, Kreativität, lege ich sehr viel Wert auf eine fehlerfreie, Seo und
            performance optimierte Umsetzung.</p>
        </div>
      </div>
    </div>
  </article>
  <article class="werte-wrapper container space">
    <div class="row">
      <div class="col-xs-12 col-sm-6">
        <div class="werte-content photography">
          <h2>Fotografie</h2>
          <p>Meine Leidenschaft ist Fotografie. Nichts ist schöner, als seine Gedanken und Vorstellungen in
            Bildern festzuhalten.</p>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6">
        <div class="werte-content about-me">
          <h2>Über mich</h2>
          <p>Mit meiner Kreativität, sowie der Antrieb zum Sport und meine Leidenschaft das beste aus mir raus
            zu holen, erkundige ich gerne die Natur, die Isar </p>
        </div>
      </div>
    </div>
  </article>
</section>
